export const Menu = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <g strokeWidth="0" />

    <g strokeLinecap="round" strokeLinejoin="round" />

    <g>
      {" "}
      <path
        d="M4 6H20M4 12H20M4 18H20"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />{" "}
    </g>
  </svg>
);
